/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';

/**
 * 
 * @export
 * @interface PtwValidationResult
 */
export interface PtwValidationResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof PtwValidationResult
     */
    readonly memberNames?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PtwValidationResult
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {I18nInfo}
     * @memberof PtwValidationResult
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof PtwValidationResult
     */
    $type?: PtwValidationResultTypeEnum;
}


/**
 * @export
 */
export const PtwValidationResultTypeEnum = {
    PtwPtw100SharedUtilitiesAppZeroExceptionsPtwValidationResultPtwPtw100SharedUtilitiesAppZero: 'Ptw.Ptw100.SharedUtilities.AppZero.Exceptions.PtwValidationResult, Ptw.Ptw100.SharedUtilities.AppZero'
} as const;
export type PtwValidationResultTypeEnum = typeof PtwValidationResultTypeEnum[keyof typeof PtwValidationResultTypeEnum];



/**
 * Check if a given object implements the PtwValidationResult interface.
 */
export function instanceOfPtwValidationResult(value?: unknown): value is PtwValidationResult {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwValidationResultTypeEnum)[0];
}

export function PtwValidationResultFromJSON(json: any): PtwValidationResult {
    return PtwValidationResultFromJSONTyped(json, false);
}

export function PtwValidationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwValidationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'memberNames': json['memberNames'] == null ? undefined : json['memberNames'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwValidationResultToJSON(value?: Omit<PtwValidationResult, 'memberNames'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'errorMessage': value['errorMessage'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

